import { render, staticRenderFns } from "./TransferClientsToBetweenClientPortfolios.vue?vue&type=template&id=362e18df"
import script from "./TransferClientsToBetweenClientPortfolios.vue?vue&type=script&lang=js"
export * from "./TransferClientsToBetweenClientPortfolios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports